import React from 'react';
import {Field} from 'redux-form/immutable';
import {SelectField} from 'redux-form-antd'
import {
    required,
    nullValue1
} from "../validDesc";
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};
const SseRelation = props => {
    const ans = '父母關係'
    const select_arr = [
        {
            value: '-1',
            label: '請選擇'
        },
        {
            value: '1',
            label: '同住'
        },
        {
            value: '2',
            label: '分住'
        },
        {
            value: '3',
            label: '分居'
        },
        {
            value: '4',
            label: '離婚'
        },
        {
            value: '5',
            label: '父亡'
        },
        {
            value: '6',
            label: '母亡'
        },
        {
            value: '7',
            label: '父母雙亡'
        },
        {
            value: '8',
            label: '父不詳'
        },
        {
            value: '9',
            label: '母不詳'
        },
        {
            value: '10',
            label: '其他'
        }
    ]
    return (
        <div>
            <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label={ans}
                   options={select_arr} name="sse_relation" type="text"></Field>
        </div>
    )
}

export default SseRelation


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/TransferStudentContaioner/TransferStudentForm/SseRelation.jsx